<template>
  <div class="default">
    <div
      class="d-flex justify-content-between"
      :style="this.isTrack ? 'float:right;' : ''"
    >
      <div class="status-dropdown" v-if="!this.isTrack">
        <div @click="showDropDown" class="drop-content">
          {{ status }}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.277 14.7522L8.45062 10.5007C8.27687 10.3076 8.41388 10 8.67361 10H16.3264C16.5861 10 16.7231 10.3076 16.5494 10.5007L12.723 14.7522C12.6038 14.8846 12.3962 14.8846 12.277 14.7522Z"
              fill="#8D99A0"
            />
          </svg>
        </div>

        <div class="menu__status-dropdown" v-if="show.status_dropdown">
          <p
            @click="changeFocusState('ontrack')"
            :class="{ active: status == 'On Track' }"
          >
            On Track
          </p>
          <p
            @click="changeFocusState('ondeck')"
            :class="{ active: status == 'On Deck' }"
          >
            On Deck
          </p>
          <p
            @click="changeFocusState('stationed')"
            :class="{ active: status == 'Stationed' }"
          >
            Stationed
          </p>
        </div>
      </div>

      <div class="ico ico-close" @click="$emit('close-dashcard')">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
          <g clip-path="url(#clip0)">
            <path
              d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
              fill="#606770"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="14.2222"
                height="14.2222"
                fill="white"
                transform="translate(8.88867 8.88889)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>

    <div class="crew">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="title">{{ this.isTrack ? "The Guides" : "The Crew" }}</h4>
        <span class="add" v-if="!this.isTrack" @click="emitAddCrew">+ Add</span>
      </div>
      <div class="crew-list">
        <div class="crew-member" v-for="(crewMember, n) in crews" :key="n">
          <h4 class="headline">{{ crewMember.role }}</h4>
          <div class="info">
            <img
              v-if="crewMember.user && crewMember.user.imgURL"
              :src="crewMember.user.imgURL"
              :alt="crewMember.nickname ? crewMember.nickname : crewMember.name"
            />
            <b-avatar v-else></b-avatar>
            <h3>
              {{ crewMember.nickname ? crewMember.nickname : crewMember.name }}
              <span v-if="crewMember.user"
                >({{
                  crewMember.user.firstname + " " + crewMember.user.lastname
                }})</span
              >
            </h3>

            <span>
              <span
                v-if="!isTrack"
                class="ico"
                @click="showEditPopup(crewMember, n)"
              >
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.66651 6.3333C5.48969 6.3333 5.32012 6.40354 5.1951 6.52857C5.07008 6.65359 4.99984 6.82316 4.99984 6.99997V16.3333C4.99984 16.5101 5.07008 16.6797 5.1951 16.8047C5.32012 16.9297 5.48969 17 5.66651 17H14.9998C15.1767 17 15.3462 16.9297 15.4712 16.8047C15.5963 16.6797 15.6665 16.5101 15.6665 16.3333V12.7733C15.6665 12.4051 15.965 12.1066 16.3332 12.1066C16.7014 12.1066 16.9998 12.4051 16.9998 12.7733V16.3333C16.9998 16.8637 16.7891 17.3725 16.4141 17.7475C16.039 18.1226 15.5303 18.3333 14.9998 18.3333H5.66651C5.13607 18.3333 4.62736 18.1226 4.25229 17.7475C3.87722 17.3725 3.6665 16.8637 3.6665 16.3333V6.99997C3.6665 6.46954 3.87722 5.96083 4.25229 5.58576C4.62736 5.21068 5.13607 4.99997 5.66651 4.99997H9.22651C9.5947 4.99997 9.89317 5.29845 9.89317 5.66664C9.89317 6.03483 9.5947 6.3333 9.22651 6.3333H5.66651Z"
                    fill="#B3C2CB"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.5284 3.86192C14.7888 3.60157 15.2109 3.60157 15.4712 3.86192L18.1379 6.52859C18.3983 6.78894 18.3983 7.21105 18.1379 7.4714L11.4712 14.1381C11.3462 14.2631 11.1767 14.3333 10.9998 14.3333H8.33317C7.96498 14.3333 7.6665 14.0349 7.6665 13.6667V11C7.6665 10.8232 7.73674 10.6536 7.86177 10.5286L14.5284 3.86192ZM8.99984 11.2761V13H10.7237L16.7237 6.99999L14.9998 5.27613L8.99984 11.2761Z"
                    fill="#B3C2CB"
                  />
                </svg>
              </span>
            </span>
            <span>
              <span v-if="!isTrack" class="ico" @click="deleteCrew(n)">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.5 4.5C1.5 4.08579 1.83579 3.75 2.25 3.75H15.75C16.1642 3.75 16.5 4.08579 16.5 4.5C16.5 4.91421 16.1642 5.25 15.75 5.25H2.25C1.83579 5.25 1.5 4.91421 1.5 4.5Z"
                    fill="#FF8C7D"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 2.25C7.30109 2.25 7.11032 2.32902 6.96967 2.46967C6.82902 2.61032 6.75 2.80109 6.75 3V3.75H11.25V3C11.25 2.80109 11.171 2.61032 11.0303 2.46967C10.8897 2.32902 10.6989 2.25 10.5 2.25H7.5ZM12.75 3.75V3C12.75 2.40326 12.5129 1.83097 12.091 1.40901C11.669 0.987053 11.0967 0.75 10.5 0.75H7.5C6.90326 0.75 6.33097 0.987053 5.90901 1.40901C5.48705 1.83097 5.25 2.40326 5.25 3V3.75H3.75C3.33579 3.75 3 4.08579 3 4.5V15C3 15.5967 3.23705 16.169 3.65901 16.591C4.08097 17.0129 4.65326 17.25 5.25 17.25H12.75C13.3467 17.25 13.919 17.0129 14.341 16.591C14.7629 16.169 15 15.5967 15 15V4.5C15 4.08579 14.6642 3.75 14.25 3.75H12.75ZM4.5 5.25V15C4.5 15.1989 4.57902 15.3897 4.71967 15.5303C4.86032 15.671 5.05109 15.75 5.25 15.75H12.75C12.9489 15.75 13.1397 15.671 13.2803 15.5303C13.421 15.3897 13.5 15.1989 13.5 15V5.25H4.5Z"
                    fill="#FF8C7D"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 7.5C7.91421 7.5 8.25 7.83579 8.25 8.25V12.75C8.25 13.1642 7.91421 13.5 7.5 13.5C7.08579 13.5 6.75 13.1642 6.75 12.75V8.25C6.75 7.83579 7.08579 7.5 7.5 7.5Z"
                    fill="#FF8C7D"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.5 7.5C10.9142 7.5 11.25 7.83579 11.25 8.25V12.75C11.25 13.1642 10.9142 13.5 10.5 13.5C10.0858 13.5 9.75 13.1642 9.75 12.75V8.25C9.75 7.83579 10.0858 7.5 10.5 7.5Z"
                    fill="#FF8C7D"
                  />
                </svg>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="calendar">
      <h2 class="title">Calendar</h2>
      <v-date-picker
        is-expanded
        mode="range"
        :value="null"
        v-model="dates"
        aria-disabled="disabled"
        is-inline
      />
    </div> -->
    <div class="engines">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="title">Engine</h4>
        <span class="add" v-if="!this.isTrack" @click="$emit('show-add-engine')"
          >+ Add</span
        >
      </div>
      <div class="status-dropdown calendar">
        <span>View As</span>
        <div
          @click="show.engine_dropdown = !show.engine_dropdown"
          class="drop-content"
        >
          {{ view_as }}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.277 14.7522L8.45062 10.5007C8.27687 10.3076 8.41388 10 8.67361 10H16.3264C16.5861 10 16.7231 10.3076 16.5494 10.5007L12.723 14.7522C12.6038 14.8846 12.3962 14.8846 12.277 14.7522Z"
              fill="#8D99A0"
            />
          </svg>
        </div>

        <div class="menu__status-dropdown" v-if="show.engine_dropdown">
          <p
            @click="
              view_as = 'row';
              show.engine_dropdown = false;
            "
            :class="{ active: view_as == 'row' }"
          >
            Row
          </p>
          <p
            @click="
              view_as = 'calendar';
              show.engine_dropdown = false;
            "
            :class="{ active: view_as == 'calendar' }"
          >
            Calendar
          </p>
        </div>
      </div>
      <div class="calendar" v-if="view_as === 'calendar'">
        <!-- <h2 class="title">Calendar</h2> -->
        <v-date-picker
          disabled
          is-expanded
          mode="range"
          :value="null"
          v-model="dates"
          aria-disabled="disabled"
          is-inline
        />
      </div>
      <div v-else>
        <div class="engine" v-for="(engine, i) in engines" :key="i">
          <div class="head__engine">
            <h5>{{ engine.text }}</h5>
            <span
              class="ico"
              v-if="!isTrack"
              @click="$emit('edit-engine', engine, i)"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.66651 6.3333C5.48969 6.3333 5.32012 6.40354 5.1951 6.52857C5.07008 6.65359 4.99984 6.82316 4.99984 6.99997V16.3333C4.99984 16.5101 5.07008 16.6797 5.1951 16.8047C5.32012 16.9297 5.48969 17 5.66651 17H14.9998C15.1767 17 15.3462 16.9297 15.4712 16.8047C15.5963 16.6797 15.6665 16.5101 15.6665 16.3333V12.7733C15.6665 12.4051 15.965 12.1066 16.3332 12.1066C16.7014 12.1066 16.9998 12.4051 16.9998 12.7733V16.3333C16.9998 16.8637 16.7891 17.3725 16.4141 17.7475C16.039 18.1226 15.5303 18.3333 14.9998 18.3333H5.66651C5.13607 18.3333 4.62736 18.1226 4.25229 17.7475C3.87722 17.3725 3.6665 16.8637 3.6665 16.3333V6.99997C3.6665 6.46954 3.87722 5.96083 4.25229 5.58576C4.62736 5.21068 5.13607 4.99997 5.66651 4.99997H9.22651C9.5947 4.99997 9.89317 5.29845 9.89317 5.66664C9.89317 6.03483 9.5947 6.3333 9.22651 6.3333H5.66651Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.5284 3.86192C14.7888 3.60157 15.2109 3.60157 15.4712 3.86192L18.1379 6.52859C18.3983 6.78894 18.3983 7.21105 18.1379 7.4714L11.4712 14.1381C11.3462 14.2631 11.1767 14.3333 10.9998 14.3333H8.33317C7.96498 14.3333 7.6665 14.0349 7.6665 13.6667V11C7.6665 10.8232 7.73674 10.6536 7.86177 10.5286L14.5284 3.86192ZM8.99984 11.2761V13H10.7237L16.7237 6.99999L14.9998 5.27613L8.99984 11.2761Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
            <span class="ico" v-if="!isTrack" @click="deleteEngine(i)">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.5 4.5C1.5 4.08579 1.83579 3.75 2.25 3.75H15.75C16.1642 3.75 16.5 4.08579 16.5 4.5C16.5 4.91421 16.1642 5.25 15.75 5.25H2.25C1.83579 5.25 1.5 4.91421 1.5 4.5Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.5 2.25C7.30109 2.25 7.11032 2.32902 6.96967 2.46967C6.82902 2.61032 6.75 2.80109 6.75 3V3.75H11.25V3C11.25 2.80109 11.171 2.61032 11.0303 2.46967C10.8897 2.32902 10.6989 2.25 10.5 2.25H7.5ZM12.75 3.75V3C12.75 2.40326 12.5129 1.83097 12.091 1.40901C11.669 0.987053 11.0967 0.75 10.5 0.75H7.5C6.90326 0.75 6.33097 0.987053 5.90901 1.40901C5.48705 1.83097 5.25 2.40326 5.25 3V3.75H3.75C3.33579 3.75 3 4.08579 3 4.5V15C3 15.5967 3.23705 16.169 3.65901 16.591C4.08097 17.0129 4.65326 17.25 5.25 17.25H12.75C13.3467 17.25 13.919 17.0129 14.341 16.591C14.7629 16.169 15 15.5967 15 15V4.5C15 4.08579 14.6642 3.75 14.25 3.75H12.75ZM4.5 5.25V15C4.5 15.1989 4.57902 15.3897 4.71967 15.5303C4.86032 15.671 5.05109 15.75 5.25 15.75H12.75C12.9489 15.75 13.1397 15.671 13.2803 15.5303C13.421 15.3897 13.5 15.1989 13.5 15V5.25H4.5Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.5 7.5C7.91421 7.5 8.25 7.83579 8.25 8.25V12.75C8.25 13.1642 7.91421 13.5 7.5 13.5C7.08579 13.5 6.75 13.1642 6.75 12.75V8.25C6.75 7.83579 7.08579 7.5 7.5 7.5Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.5 7.5C10.9142 7.5 11.25 7.83579 11.25 8.25V12.75C11.25 13.1642 10.9142 13.5 10.5 13.5C10.0858 13.5 9.75 13.1642 9.75 12.75V8.25C9.75 7.83579 10.0858 7.5 10.5 7.5Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
          </div>
          <div class="days__engine">
            <div
              class="day"
              v-for="(day, index) in days"
              :key="index"
              :class="{ active: engine.when.includes(day) }"
            >
              {{ day }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot-text">
      <p>Created Sep 2020</p>
      <p>Created Sep 2020</p>
      <p>Last Seen Sep 21, 2020 at 8:00pm</p>
    </div>
    <add-crew-popup
      v-if="editPopup"
      ptitle="Edit Crew"
      :nickname="activeEditCrew.nickname"
      :email="activeEditCrew.email"
      :role="activeEditCrew.role"
      :index="activeEditCrew.index"
      @addCrew="editCrew"
    ></add-crew-popup>
    <modal :id="deleteModal">
      <div class="add-tag del-tag">
        <span class="close-icon" @click="$bvModal.hide(deleteModal)">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="10.6667"
                  height="10.6667"
                  fill="white"
                  transform="translate(6.6665 6.66675)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h3>Delete {{ entity }}</h3>
        <div class="warning-msg">
          <p>
            Are you sure want to delete
            <strong>
              {{ entity }}
            </strong>
            ?
          </p>
        </div>
        <div class="d-flex justify-content-between">
          <b-button variant="danger btn-round-fill " @click="deleteConfirm">
            Yes! Delete
          </b-button>
          <b-button class="btn-simple" @click="$bvModal.hide(deleteModal)">
            No! back
          </b-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import AddCrewPopup from "@/components/dashcard/components/AddCrewPopup";
import Modal from "../../common/modal";
export default {
  props: {
    dates: Object,
    status_dropdown: Boolean,
    editPopup: Boolean,
    crews: Array,
    engines: Array,
    state: String,
    isTrack: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  components: {
    AddCrewPopup,
    Modal
  },
  data() {
    return {
      deleteModal: "deleteModal",
      entity: "",
      index: "",
      show: {
        status_dropdown: this.status_dropdown,
        engine_dropdown: false
      },
      days: ["Su", "M", "Tu", "W", "Th", "F", "Sa"],
      activeEditCrew: {},
      view_as: "row"
    };
  },
  computed: {
    status() {
      let status = "";
      if (this.state == "ontrack") status = "On Track";
      else if (this.state == "ondeck") status = "On Deck";
      else if (this.state == "stationed") status = "Stationed";
      return status;
    }
  },
  watch: {
    status_dropdown(newval) {
      this.show.status_dropdown = newval;
    },
    status() {
      this.$emit("toogleDropdown");
    }
    // editPopup(newval){
    //   this.show.editPopup = newval
    // }
  },
  methods: {
    changeFocusState(state) {
      this.$emit("changeFocusState", state);
    },
    showDropDown() {
      this.$emit("toogleDropdown");
    },
    emitAddCrew() {
      this.$emit("showAddCrew");
    },
    showEditPopup(crew, n) {
      this.$emit("showEditPopup");
      this.activeEditCrew.nickname = crew.nickname;
      this.activeEditCrew.email = crew.user.email;
      this.activeEditCrew.role = crew.role;
      this.activeEditCrew.index = n;
      console.log(this.activeEditCrew);
    },
    editCrew(crew) {
      console.log(crew);
      this.$emit("editCrew", crew);
    },
    deleteCrew(index) {
      this.entity = "Crew";
      this.index = index;
      this.$bvModal.show("deleteModal");
    },
    deleteConfirm() {
      if (this.entity == "Crew") {
        this.$emit("deleteCrew", this.index);
        this.$bvModal.hide("deleteModal");
      } else {
        this.$emit("deleteEngine", this.index);
        this.$bvModal.hide("deleteModal");
      }
    },
    deleteEngine(index) {
      this.entity = "Engine";
      this.index = index;
      this.$bvModal.show("deleteModal");
    },
    getPP(uid) {
      if (
        this.$store.getters["user/listNames"].filter(el => el.uid === uid)[0] &&
        this.$store.getters["user/listNames"].filter(el => el.uid === uid)[0]
          .connection
      ) {
        return this.$store.getters["user/listNames"].filter(
          el => el.uid === uid
        )[0].connection.imgURL;
      } else {
        return null;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.add-crew-popup {
  width: 328px;
  height: 307px;
  position: absolute;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  background-color: #fff;
  top: 25%;
  right: 0;
  padding: 24px 16px;
  z-index: 3;
  .title {
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
  }
}
.default {
  padding: 24px;
  position: relative;
  .ico-close {
    //position: absolute;
    //top: 5px;
    //right: 12px;
    cursor: pointer;
  }
  .status-dropdown {
    position: relative;
    max-width: 130px;
    width: 100%;
    border: 1px solid #dddddd;
    &.calendar {
      border: none;
      width: fit-content;
      max-width: unset;
      display: flex;
      align-items: center;
      column-gap: 12px;
      span {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #8d99a0;
      }
    }
    .drop-content {
      padding: 10px 15px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
      text-transform: capitalize;
    }
    border-radius: 8px;
    .menu__status-dropdown {
      position: absolute;
      z-index: 3;
      background-color: #fff;
      top: 110%;
      left: 50%;
      transform: translateX(-50%);
      box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      width: 155px;
      padding: 16px;
      p {
        margin: 8px 0;
        cursor: pointer;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        &.active {
          color: var(--theme-color);
        }
      }
    }
  }
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
  }
  .add {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: var(--theme-color);
    cursor: pointer;
  }
  .crew {
    margin-top: 36px;
    .crew-list {
      .crew-member {
        margin-bottom: 16px;
        .headline {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          color: #8d99a0;
          margin-bottom: 4px;
        }
        .info {
          display: grid;
          grid-template-columns: 40px 1fr 35px 25px;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            object-fit: cover;
            border-radius: 50%;
          }
          h3 {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 22px;
            color: #474d52;
            margin: 0 0 0 10px;
          }
          span {
            font-weight: bold;
            font-size: 12px;
          }
          .ico {
            cursor: pointer;
            display: none;
            transition: all 0.4s linear;
          }
          &:hover {
            .ico {
              display: block;
            }
          }
        }
      }
    }
  }
  .engines {
    .engine {
      margin: 16px 0;
      svg {
        display: none;
      }
      &:hover {
        svg {
          display: block;
        }
      }
      .head__engine {
        margin-bottom: 14px;
        display: grid;
        grid-template-columns: 1fr 40px 22px;
        .ico {
          justify-self: center;
          cursor: pointer;
        }

        h5 {
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          margin: 0;
        }
      }
      .days__engine {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .day {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #ddbc9e;
          display: flex;
          justify-content: center;
          align-items: center;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 22px;
          color: #fff;
          cursor: pointer;
          &.active {
            background-color: var(--theme-color);
          }
        }
      }
    }
  }
  .foot-text {
    margin-top: 20px;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
      margin: 0;
    }
  }
}
</style>
